import { mapGetters, mapMutations } from "vuex";

import HlpLazyLoadModal from "@Helpers/functions/lazyLoadModal";

export default {
  data: () => ({
    bfcmCouponCode: "BFCM2025",
  }),

  computed: {
    ...mapGetters([
      "getBfcmDateNow",
      "getBfcmDatePreStart",
      "getBfcmDatePreEnd",
      "getBfcmDateBfStart",
      "getBfcmDateBfEnd",
      "getBfcmDatePostBfStart",
      "getBfcmDatePostBfEnd",
      "getBfcmDateCmStart",
      "getBfcmDateCmEnd",
      "isUserLoggedIn",
    ]),

    /**
     * Determines the current Black Friday/Cyber Monday (BFCM) period based on the provided conditions.
     *
     * @returns {Object} An object representing the current BFCM period, including its name and path.
     */
    getBfcmPeriodRoute() {
      /* prettier-ignore */
      const periods = [
        { name: "homepage", active: () => this.getBfcmDateNow < this.getBfcmDatePreStart },
        { name: "bf2023", active: () => this.isBfcmPreSaleOn || this.isBfcmBlackFridayOn },
        { name: "cm2023", active: () => this.isBfcmCyberMondayOn || this.isBfcmPostSaleOn },
      ];

      let period = periods.find((period) => period.active());
      period = period || periods[periods.length - 1];

      return period.name;
    },

    inBfcmLandingPage() {
      return ["bf2023", "cm2023"].includes(this.$route.name);
    },

    isBfcmPreSaleOn() {
      return (
        this.getBfcmDateNow >= this.getBfcmDatePreStart &&
        this.getBfcmDateNow <= this.getBfcmDatePreEnd
      );
    },

    isBfcmBlackFridayOn() {
      return (
        this.getBfcmDateNow >= this.getBfcmDateBfStart &&
        this.getBfcmDateNow <= this.getBfcmDatePostBfEnd
      );
    },

    isBfcmPostBlackFridayOn() {
      return (
        this.getBfcmDateNow >= this.getBfcmDatePostBfStart &&
        this.getBfcmDateNow <= this.getBfcmDatePostBfEnd
      );
    },

    isBfcmCyberMondayOn() {
      return (
        this.getBfcmDateNow >= this.getBfcmDateCmStart &&
        this.getBfcmDateNow <= this.getBfcmDateCmEnd
      );
    },

    isBfcmPostSaleOn() {
      return this.getBfcmDateNow > this.getBfcmDateCmEnd;
    },

    isBfcmRunning() {
      return this.isDateBetween(
        this.getBfcmDateNow,
        this.getBfcmDatePreStart,
        this.getBfcmDateCmEnd,
      );
    },

    /**
     * Checks if the BFCM promo is visible based on the user's subscription status.
     *
     * @returns {boolean} True if the promo is visible, false otherwise.
     */
    isBfcmPromoVisible() {
      const value = JSON.parse(localStorage.getItem("isBfcmPromoVisible"));
      return value === true || value === null;
    },

    isBfcmBannerVisible() {
      const isVisible = this.isBfcmPromoVisible;
      const isBfcm = this.isBfcmBlackFridayOn || this.isBfcmCyberMondayOn;

      return isVisible && isBfcm;
    },
  },

  methods: {
    ...mapMutations(["SET_BFCM_DATE_NOW"]),

    isDateBetween(nowDate, startDate, endDate) {
      return nowDate > startDate && nowDate < endDate;
    },

    handleCountdownEnd(shouldRedirect = undefined) {
      // re-simulate the date
      this.simulateDate();
      if (shouldRedirect) this.goToLanding();
    },

    shouldApplyCouponWhenSubscribing(subscription) {
      if (
        this.isBfcmRunning &&
        (this.isBfcmBlackFridayOn || this.isBfcmCyberMondayOn) &&
        subscription.interval === "yearly"
      ) {
        return true;
      } else if (!this.isBfcmRunning) {
        return true;
      }

      return false;
    },

    goToLanding() {
      this.$router.push({
        name: this.getBfcmPeriodRoute,
      });
    },

    showBfcmModal() {
      if (!this.isBfcmPromoVisible) return false;

      function isModalClosed(modal) {
        return JSON.parse(localStorage.getItem(modal));
      }

      let isBfModalVisible = this.isBfcmBlackFridayOn;
      isBfModalVisible = isBfModalVisible && !isModalClosed("isBfModalClosed");

      let isCmModalVisible = this.isBfcmCyberMondayOn;
      isCmModalVisible = isCmModalVisible && !isModalClosed("isCmModalClosed");

      if (isBfModalVisible || isCmModalVisible) {
        Bus.$emit("showModal", HlpLazyLoadModal("Bfcm2023"));
      }
    },

    simulateDate() {
      let now = new Date();
      now = now.getTime();

      this.SET_BFCM_DATE_NOW(now);
    },
  },

  created() {
    this.simulateDate();
  },
};
